import script from "./ClientComponentsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientComponentsSelector.vue?vue&type=script&setup=true&lang=js"

import "./ClientComponentsSelector.vue?vue&type=style&index=0&id=7c66d01c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c66d01c"]])

export default __exports__